import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	CUSTOM_ELEMENTS_SCHEMA,
	Input,
	input,
} from '@angular/core';

import type { StoryblokRichTextNode } from '@storyblok/richtext';
import { richTextResolver } from '@storyblok/richtext';

import { ReadMoreComponent } from '@valk-nx/components/ui-read-more/src/lib/read-more';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sb-richtext',
	templateUrl: './rich-text.html',
	imports: [ReadMoreComponent, NgClass, StoryblokDirective, NgTemplateOutlet],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RichTextComponent extends StoryblokRootDirective {
	@Input() listStyle: 'list-checkmarks' | 'list-bullets' = 'list-bullets';
	@Input() isReadMore = false;
	@Input() maxWidth: 'max-w-screen-md' | 'section-inner' | 'max-w-full' =
		'max-w-screen-md';

	content = input<string | StoryblokRichTextNode<string>>('');
	richTextResolvers = input<Record<string, unknown>>();

	renderedRichText = computed<string>(() => {
		const content = this.content();
		if (typeof content !== 'string') {
			return richTextResolver<string>({
				tiptapExtensions: this.richTextResolvers(),
			}).render(content);
		} else {
			return content;
		}
	});
}
